import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/courseResume';
import { FILTER_TYPE } from 'data/filterType';
import DateInput from 'components/DateInput';
import Field from 'components/Field';
import styles from './UntilToBeResumedDateFilter.module.scss';

function UntilToBeResumedDateFilter() {
  const dispatch = useDispatch();
  const { untilToBeResumedDate } = useSelector(currentFiltersSelector);

  const handleOnChange = useCallback(
    (date) => {
      dispatch(
        setFilterValue({
          key: COURSE_PAUSE_REQUEST_FILTERS.untilToBeResumedDate,
          value: date,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="To Be Resume Date (To)"
      labelClassName="h5"
    >
      <DateInput
        className={styles.dateInput}
        value={untilToBeResumedDate}
        onChange={handleOnChange}
        placement="top"
      />
    </Field>
  );
}

export default UntilToBeResumedDateFilter;
